import apiClient from './apiClient'

function processReleaseNoteImages(html: string): string {
  if (!html.includes('<img')) return html
  return html.replace(/<img/g, '<img class="versionimage max-w-full h-auto" alt="filepreviewpopup"')
}

export interface ReleaseNote {
  id: number
  version_title: string
  version_description: string
  version_date: string
  version_type: 'PROCESS_CHANGE' | 'PROCESS_IMPROVEMENT' | 'NEW_FEATURE' | string
  is_read?: string | number | null
}

export interface ReleaseNotesResponse {
  success?: boolean
  data: ReleaseNote[]
  total?: number
}

/**
 * Fetch release notes for the user drawer (matches Angular loadcodeupdates).
 */
export async function fetchReleaseNotes(): Promise<ReleaseNotesResponse> {
  const response = await apiClient.get<ReleaseNotesResponse>('/api/release_notes', {
    params: {
      sortBy: 'desc',
      orderBy: 'version_date',
      type: true,
    },
  })

  const payload = response.data
  if (payload?.data) {
    payload.data = payload.data.map((note) => ({
      ...note,
      version_description: note.version_description
        ? processReleaseNoteImages(note.version_description)
        : note.version_description,
    }))
  }

  return payload
}

/**
 * Mark a release note as read (matches Angular codeupdateMarkRead).
 */
export async function markReleaseNoteRead(id: number, isRead = 1): Promise<void> {
  await apiClient.get(`/api/is_read/${id}`, { params: { is_read: isRead } })
}
